"use strict";
import { Options as ModelOptions } from "@ym-framework/model";
import { ScannerModels } from "@/configuration/scanner";
ModelOptions.strict = false;
for (const _model of ScannerModels) {
  if (!_model.model) {
    continue;
  }
  ModelOptions.mapper.add(_model);
}
